import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { cn } from "design-system/utils"
import { Globe, Mail, Server } from "lucide-react"
import { GoogleIcon } from "modules/shared/icons/google"
import { InstagramIcon } from "modules/shared/icons/instagram"
import { MessengerIcon } from "modules/shared/icons/messenger"
import { OutlookIcon } from "modules/shared/icons/outlook"
import { WhatsappIcon } from "modules/shared/icons/whatsapp"
import { useMemo } from "react"
import { ChannelEnum } from "schema"

type Props = {
  channel: keyof typeof ChannelEnum | null | undefined
  withTooltip?: boolean
  className?: string
}

export const ChannelIcon = ({ channel, withTooltip = false, className }: Props) => {
  const channelName = useMemo(() => {
    switch (channel) {
      case ChannelEnum.Whatsapp:
        return "WhatsApp"
      case ChannelEnum.Web:
        return "Web"
      case ChannelEnum.Instagram:
        return "Instagram"
      case ChannelEnum.Messenger:
        return "Messenger"
      case ChannelEnum.Gmail:
        return "Gmail"
      case ChannelEnum.Outlook:
        return "Outlook"
      case ChannelEnum.Email:
        return "Email"
      case ChannelEnum.Api:
        return "API"
      default:
        return channel
    }
  }, [channel])

  const Icon = useMemo(() => {
    switch (channel) {
      case ChannelEnum.Whatsapp:
        return WhatsappIcon
      case ChannelEnum.Web:
        return Globe
      case ChannelEnum.Instagram:
        return InstagramIcon
      case ChannelEnum.Messenger:
        return MessengerIcon
      case ChannelEnum.Gmail:
        return GoogleIcon
      case ChannelEnum.Outlook:
        return OutlookIcon
      case ChannelEnum.Email:
        return Mail
      case ChannelEnum.Api:
        return Server
      default:
        return null
    }
  }, [channel])

  if (!channel) {
    return <span className="text-muted-foreground">{"-"}</span>
  }

  const iconElement = (
    <span className={cn("inline-flex items-center", className)}>
      {Icon && <Icon className="size-4.5" />}
    </span>
  )

  if (!withTooltip) return iconElement

  return (
    <Tooltip>
      <TooltipTrigger asChild>{iconElement}</TooltipTrigger>
      <TooltipContent>{channelName}</TooltipContent>
    </Tooltip>
  )
}
